import React, {useState, useRef, useEffect} from 'react';
import {Link} from 'react-router-dom';

import {useUser} from '../utils/UserSession';
import {getInitial} from '../utils/formatString';
import {SECTION_SELECTED_KEY} from '../utils/membershipUi';
import logoGomunity from '../assets/logo_go-munity-softoro.png';

const LOGOUT_MENU_ID = 'gc-topbar-logout-menu';

// Rebranding 2026 · AppBar → gc-topbar (fascia 1 antracite, logo bianco, avatar oro)
const AppBar = () => {
  const {user} = useUser();
  const [showLogout, setShowLogout] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!showLogout) {
      return;
    }

    const handleClickOutside = e => {
      if (!menuRef.current?.contains(e.target)) {
        setShowLogout(false);
      }
    };

    const handleEscape = e => {
      if (e.key === 'Escape') {
        setShowLogout(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [showLogout]);

  return (
    <header className="gc-topbar gc-topbar--ivory">
      <div className="gc-topbar__inner">
        <Link
          to="/dashboard"
          onClick={() => localStorage.removeItem(SECTION_SELECTED_KEY)}
          className="gc-topbar__logo-link"
        >
          <img
            className="gc-topbar__logo"
            alt="Go-munity"
            src={logoGomunity}
          />
        </Link>

        <div className="gc-topbar__right">
          <a
            href="https://giocamondo.it/club/"
            target="_blank"
            rel="noopener noreferrer"
            className="gc-topbar__external-link"
          >
            Giocamondo.it ↗
          </a>

          <div ref={menuRef} className="gc-topbar__user-menu">
            <button
              type="button"
              className="gc-topbar__user-trigger"
              aria-label={`Menu utente · ${user.firstName} ${user.lastName}`}
              aria-expanded={showLogout}
              aria-haspopup="menu"
              aria-controls={LOGOUT_MENU_ID}
              onClick={() => setShowLogout(prev => !prev)}
            >
              <span className="gc-topbar__greet">Ciao {user.firstName}</span>
              <span className="gc-topbar__avatar">
                {getInitial(user.firstName) + getInitial(user.lastName)}
              </span>
            </button>

            {showLogout && (
              <Link
                id={LOGOUT_MENU_ID}
                to="/logout"
                className="gc-topbar__logout-menu"
                role="menuitem"
              >
                Logout
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppBar;
